module.exports = __webpack_public_path__ + "img/1.2ba51018.png";